import { useEffect, useState } from 'react';

import { authClient } from '../lib/auth-client';
import type { Session, SessionUser } from '../lib/session';

export interface AuthState {
  session: Session | null;
  user: SessionUser | null;
  loading: boolean;
}

export function useAuth(): AuthState {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      /* INVARIANT : `loading` doit retomber quoi qu'il arrive. Un rejet ici
         (session expirée, panne réseau, charge utile inattendue) laisserait
         toute page derrière ProtectedRoute sur son écran de chargement,
         définitivement. L'abonnement ci-dessous reste le chemin de rattrapage. */
      try {
        const { data } = await authClient.getSession();
        if (!cancelled) setSession(data.session);
      } catch {
        if (!cancelled) setSession(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    const { data: sub } = authClient.onAuthStateChange((_event, s) => {
      setSession(s);
    });

    return () => {
      cancelled = true;
      sub.subscription.unsubscribe();
    };
  }, []);

  return { session, user: session?.user ?? null, loading };
}
